import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  Font
} from "@react-pdf/renderer";
import BackgroundImage from "./assets/pie_imagen.png";

Font.register({
    family: "Roboto",
    fonts: [
      { src: "/fonts/Roboto-Regular.ttf" },
      { src: "/fonts/Roboto-Bold.ttf", fontWeight: "bold" },
    ],
  });

const styles = StyleSheet.create({
  page: {
    position: "relative",
    backgroundColor: "#ffffff",
    width: "100%",
    height: "100%",
    padding: 0,
    lineHeight: "1.4px",
    fontSize: 10,
    textAlign: "justify",
    fontFamily: "Roboto",
  },
  container: {
    flexDirection: "column",
    position: "absolute",
    top: 100,
  },
  backgroundImage: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  header: {
    marginLeft: 30,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
  section: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 5,
    marginBottom: 5,
  },
  cotizacion: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    fontSize: 12,
  },
  condiciones: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    fontSize: 8.5,
  },
  firma: {
    marginLeft: 30,
    marginRight: 30,
    marginTop: 5,
    marginBottom: 5,
    fontFamily: "Roboto",
    fontWeight: "bold",
  },
});

const PresupuestoPDFDocument = ({ datos }) => (
    
  <Document>
        <Page size="A4" style={styles.page}>
          <View style={styles.backgroundImage}>
            <Image src={BackgroundImage} style={styles.backgroundImage} />
          </View>
          <View style={styles.container}>
            <View>
              <Text style={styles.header}>Presupuesto N° {datos.docId}</Text>
  
              <View style={styles.section}>
                <Text>
                  Mendoza,{" "}
                  {new Date(
                    new Date(datos.fecha).toLocaleString("en-US", {
                      timeZone: "UTC",
                    })
                  ).toLocaleDateString("es-ES")}
                </Text>
                <Text>
                  Sres.: {datos.nombre} {datos.empresa}
                </Text>
                <Text>Contacto: {datos.telefonoCliente}</Text>
                <Text>Correo: {datos.emailCliente}</Text>
                <Text>
                  De: CATA Internacional L.T.D.A. / CUIT Nº 33-54662883-9
                </Text>
              </View>
  
              <View style={styles.section}>
                <Text>
                  De acuerdo a lo solicitado enviamos cotización del servicio a
                  realizar. Este presupuesto pueden modificarse por circunstancias
                  externas o imprevistos durante el traslado.
                </Text>
              </View>
  
              <View style={styles.section}>
                <Text>
                  Salida:{" "}
                  {new Date(
                    new Date(datos.fechaSalida).toLocaleString("en-US", {
                      timeZone: "UTC",
                    })
                  ).toLocaleDateString("es-ES")}
                  . Hora: {datos.horaSalida}
                </Text>
                <Text>Desde: {datos.lugarSalida}</Text>
                <Text>Hasta: {datos.lugarDestino}</Text>
                <Text>Pasajeros: {datos.cantidadPasajeros}</Text>
                <Text>Unidades: {datos.unidadesSolicitadas}</Text>
                <Text>Servicio Adicional: {datos.tipoServicio}</Text>
                <Text>Kms. adicionales: {datos.kilometrosAdicionales}</Text>
                <Text>
                  Regreso:{" "}
                  {new Date(
                    new Date(datos.fechaRegreso).toLocaleString("en-US", {
                      timeZone: "UTC",
                    })
                  ).toLocaleDateString("es-ES")}
                  . Hora: {datos.horaRegreso}
                </Text>
                <Text>{datos.observaciones}</Text>
              </View>
  
              <View style={styles.section}>
                <Text style={styles.cotizacion}>
                  El total del servicio presupuestado es de {datos.totalServicio}{" "}
                  (impuestos incluídos).
                </Text>
              </View>
              <View style={styles.section}>
                <Text>
                  Es importante tener en cuenta que el servicio presupuestado,
                  está sujeto a variaciones de los costos de transporte.
                </Text>
              </View>
  
              <View style={styles.section}>
                <Text style={styles.condiciones}>
                  <Text>Condiciones de Reserva: </Text>
                  Este presupuesto tiene una vigencia de 30 días.
                  Para asegurar la disponibilidad del servicio en la fecha programada,
                  es necesario confirmar el presupuesto dentro de un plazo máximo de 10
                  días hábiles antes del día de prestación del servicio. Asimismo, para garantizar
                  una organización óptima, el servicio debe estar facturado,
                  con la firma y del contrato convenido y abonado en su
                  totalidad antes de su salida. Este documento es una cotización y
                  no implica ninguna reserva.
                </Text>
              </View>
  
              <View style={styles.section}>
                <Text>
                  ¡Estamos disponibles para atender cualquier consulta y esperamos
                  poder servirte pronto!
                </Text>
                <Text>Gracias por contar con nosotros.</Text>
              </View>
  
              <View style={styles.firma}>
                <Text>Atentamente,</Text>
                <Text>{datos.nombreEjecutivo}</Text>
                <Text>{datos.correoEjecutivo}</Text>
                <Text>{datos.telefonoEjecutivo}</Text>
              </View>
            </View>
          </View>
        </Page>
      </Document>
);

export default PresupuestoPDFDocument;